module.exports = __webpack_public_path__ + "1d80fa51ee7faad18e9a36f8354aabbc.jpg";